export default (order_by: string = '') => (order_by === 'created' ? 'DESC' : 'ASC');
